// Filling an appointment in from the listing details recorded beneath it.
//
// The appearance pane already knows the client, the file number, the appearance type, the
// court and the times. Typing them again into the appointment above is duplicate work, and
// duplicate work is where two records start to disagree with each other.
//
// Everything here returns "" or null when it has nothing to say, so a caller can tell the
// difference between a value and an absence and leave the field alone.

function clean(value) {
  return String(value ?? "").trim();
}

// "Jane Smith - 2024/1234 - Mention"
//
// Parts that are missing are left out rather than appearing as gaps or stray separators: a
// title reading "Jane Smith -  - " is worse than one reading "Jane Smith".
export function appointmentTitleFromListing(listing) {
  const parts = [
    clean(listing?.clientName),
    clean(listing?.fileNumber),
    clean(listing?.appearanceType),
  ].filter(Boolean);
  return parts.join(" - ");
}

// The court and where in it, which are separate fields because they answer different
// questions - "Melbourne Magistrates' Court" and "Courtroom 4". A calendar entry wants
// both, since the first is where to drive and the second is where to stand.
export function appointmentLocationFromListing(listing) {
  const parts = [clean(listing?.court), clean(listing?.listingLocation)].filter(Boolean);
  return parts.join(" - ");
}

// The datetime-local format the appointment fields use: YYYY-MM-DDTHH:mm.
//
// Returns null unless there is a date and both times, because a half-filled listing would
// otherwise move the appointment to a time nobody chose.
export function appointmentTimesFromListing(listing) {
  const date = clean(listing?.date);
  const startTime = clean(listing?.startTime);
  const endTime = clean(listing?.endTime);
  if (!date || !startTime || !endTime) return null;

  // A listing that ends before it starts is a typo in the listing, not an instruction to
  // create an impossible appointment.
  if (endTime <= startTime) return null;

  return { start: `${date}T${startTime}`, end: `${date}T${endTime}` };
}
